// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__so95K","row":"Node_row__2FSBc","label":"Node_label__X_3R9","footer":"Node_footer__1LgIa"};